var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0651 10.1113H4.58794C4.24337 10.1113 3.96484 10.3899 3.96484 10.7344C3.96484 11.079 4.24337 11.3575 4.58794 11.3575H12.0651C12.4097 11.3575 12.6882 11.079 12.6882 10.7344C12.6882 10.3899 12.4097 10.1113 12.0651 10.1113Z",
    fill: "#484848",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58794 3.88096H12.0651C12.4097 3.88096 12.6882 3.60243 12.6882 3.25786C12.6882 2.91329 12.4097 2.63477 12.0651 2.63477H4.58794C4.24337 2.63477 3.96484 2.91329 3.96484 3.25786C3.96484 3.60243 4.24337 3.88096 4.58794 3.88096Z",
    fill: "#484848",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0992 2.47266C1.66615 2.47266 1.31348 2.8272 1.31348 3.26398C1.31348 3.69641 1.66615 4.04847 2.0992 4.04847C2.53225 4.04847 2.88555 3.69641 2.88555 3.26398C2.88555 2.8272 2.53225 2.47266 2.0992 2.47266Z",
    fill: "#484848",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0992 9.94922C1.66615 9.94922 1.31348 10.3038 1.31348 10.7406C1.31348 11.173 1.66615 11.525 2.0992 11.525C2.53225 11.525 2.88555 11.173 2.88555 10.7406C2.88555 10.3038 2.53225 9.94922 2.0992 9.94922Z",
    fill: "#484848",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0641 6.37402H4.58696C4.24239 6.37402 3.96387 6.65255 3.96387 6.99712C3.96387 7.34169 4.24239 7.62022 4.58696 7.62022H12.0641C12.4087 7.62022 12.6872 7.34169 12.6872 6.99712C12.6872 6.65255 12.4087 6.37402 12.0641 6.37402Z",
    fill: "#484848",
    fillOpacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0992 6.2998C1.66615 6.2998 1.31348 6.65185 1.31348 7.08491C1.31348 7.51734 1.66615 7.87001 2.0992 7.87001C2.53225 7.87001 2.88555 7.51734 2.88555 7.08491C2.88555 6.65185 2.53225 6.2998 2.0992 6.2998Z",
    fill: "#484848",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListGray);
export default __webpack_public_path__ + "static/media/list_gray.415ca6ab5a74ed9afde43e66a54ca592.svg";
export { ForwardRef as ReactComponent };